import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { useAuthModal } from '@/features/auth'
import { useSmoothScroll } from '../hooks/use-smooth-scroll'

/**
 * Final CTA section with call to action
 * Implementation: LAND2-006
 */
export function FinalCTASection() {
  const { t } = useTranslation()
  const { openAuthModal } = useAuthModal()
  const { scrollToHowItWorks } = useSmoothScroll()

  return (
    <div className="bg-primary py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        {/* Headline */}
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          {t('landing.cta.headline')}
        </h2>

        {/* Subline */}
        <p className="mx-auto mt-4 max-w-2xl text-lg text-white/80 sm:text-xl">
          {t('landing.cta.subline')}
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
          {/* Primary CTA with pulse animation */}
          <button
            onClick={() => openAuthModal()}
            className={cn(
              'rounded-lg bg-accent px-8 py-4 text-lg font-semibold text-white',
              'transition-all duration-200 ease-out',
              'hover:-translate-y-0.5 hover:bg-accent-hover hover:shadow-lg',
              'focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2 focus:ring-offset-primary',
              'animate-subtle-pulse'
            )}
          >
            {t('landing.cta.primary')}
          </button>

          {/* Secondary CTA */}
          <button
            onClick={scrollToHowItWorks}
            className={cn(
              'rounded-lg border-2 border-white/30 bg-transparent px-8 py-4 text-lg font-semibold text-white',
              'transition-all duration-200 ease-out',
              'hover:border-white/60 hover:bg-white/10',
              'focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-primary'
            )}
          >
            {t('landing.cta.secondary')}
          </button>
        </div>

        {/* Reassurance line */}
        <p className="mt-8 text-sm text-white/60">
          {t('landing.cta.reassurance')}
        </p>
      </div>

      {/* CSS for pulse animation */}
      <style>{`
        @keyframes subtle-pulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.4);
          }
          50% {
            box-shadow: 0 0 0 8px rgba(249, 115, 22, 0);
          }
        }
        .animate-subtle-pulse {
          animation: subtle-pulse 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  )
}
